import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// pickupdrop - Get All (Read)
export const GetAll = createAsyncThunk(
  "ServiceAdmin/dashboard",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Dashboard.dashboard}`);


      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const Slice = createSlice({
  name: "dashboard",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {

        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data || [];
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
